import React from 'react';
import './App.css';

function App() {
  return (
    <div className="landing-page">
      <header className="header">
        Maurisa Riviera
      </header>
      <div className="video-container">
        <div className="iframe-wrapper">
        <video controls 
          width="100%"
          height="100%"
          className="video">
        <source src="https://weddingvideosa.blob.core.windows.net/videoscon/ILoveYouMaurisaPatrickFinal.mp4" type="video/mp4" />
        {/* <source src="https://weddingvideosa.blob.core.windows.net/videoscon/ILoveYouMaurisaPatrick.mp4" type="video/mp4" /> */}
        Your browser does not support the video tag.
      </video>
        </div>
      </div>
    </div>
  );
}

export default App;